import React, { Component } from "react";
import SimpleReactValidator from "simple-react-validator";
import { connect } from "react-redux";
import moment from "moment";
import Instructions from "./Step1Instructions";
import { Text } from "react-internationalization";
import Button from "../../../Utils/GenericUI/Button";
const ie =
  navigator.userAgent.indexOf("MSIE") > -1 ||
  navigator.userAgent.indexOf("rv:") > -1;

class Step1 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formerEmpOfSharp: false,
      phoneLabel: "HM",
    };
    this.validator = new SimpleReactValidator();
  }
  static getDerivedStateFromProps(nextProps) {
    const { planCategory } = nextProps;
    if (planCategory === "GROUP") {
      return { formerEmpOfSharp: true };
    }
  }
  render() {
    const { data, selectedPlan, planCategory, clickedSaveNextIds } = this.props;
    const { Socialnumber } = this.props?.data;
    const { formerEmpOfSharp } = this.state;
    return (
      <React.Fragment>
        {/* <div class="tab-content tab-contentSharp"> */}
        <div
          id="step1"
          class={
            this.props.preEnrollInfo?.appStatus != "READY" &&
            this.props.preEnrollInfo?.appStatus != "SUBMITTED"
              ? "container tab-pane active"
              : "container tab-pane active disable-form"
          }
        >
          {console.log(planCategory)}
          {planCategory === "INDIVIDUAL" || planCategory === "RETIREE" ? (
            <React.Fragment>
              <Instructions selectedPlan={planCategory} />
              <br />
              <h3 class="tab-heading">
                <Text id="app.STEP1Sharp" /> – <Text id="app.stepSub" />
              </h3>
            </React.Fragment>
          ) : null}
          {planCategory === "GROUP" ? (
            <React.Fragment>
              <Instructions selectedPlan={selectedPlan} />
              <br />
              <h3 class="tab-heading">
                <Text id="app.STEP1Sharp" /> : <Text id="app.PERSONALINFO" />
              </h3>
            </React.Fragment>
          ) : null}

          <div class="form-panel">
            <p>
              <strong>
                <Text id="app.AParaSharp" />:
              </strong>
            </p>
            {planCategory === "RETIREE" ? (
              <>
                <div class="radio radio-tab">
                  <label for="sandiego" class="control-label">
                    <Text id="app.san" />*
                  </label>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="retiree"
                    id="retireey"
                    value="Y"
                    checked={data.retiree === "Y"}
                    onChange={this.props.handleChange}
                  />
                  <label for="sandiego" class="radio-sandiego-retiree">
                    <Text id="app.Yes" />
                  </label>
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="retiree"
                    id="retireen"
                    value="N"
                    checked={data.retiree === "N"}
                    onChange={this.props.handleChange}
                  />
                  <label for="sandiego" class="radio-sandiego-retiree">
                    No
                  </label>
                </div>
                {data.retiree === "Y" ? (
                  <>
                    {planCategory === "RETIREE" ? (
                      <>
                        <div class="radio radio-tab">
                          <label for="medicareEligible" class="control-label">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <Text id="app.san9" />
                          </label>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="radio"
                            name="medicareEligible"
                            id="medicareEligibleY"
                            value="Y"
                            checked={data.medicareEligible === "Y"}
                            onChange={this.props.handleChange}
                          />{" "}
                          <label
                            for="medicareEligibletY"
                            class="radio-sandiego-retiree"
                          >
                            <Text id="app.Yes" />
                          </label>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="radio"
                            name="medicareEligible"
                            id="medicareEligibleN"
                            value="N"
                            checked={data.medicareEligible === "N"}
                            onChange={this.props.handleChange}
                          />
                          <label
                            for="medicareEligibleN"
                            class="radio-sandiego-retiree"
                          >
                            {" "}
                            No
                          </label>
                          <label class="control-label">
                            <Text
                              id={
                                planCategory === "RETIREE"
                                  ? "app.san10"
                                  : "app.san2"
                              }
                            />
                          </label>
                          {planCategory === "RETIREE" ? (
                            <label class="control-label">
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <Text id="app.san11" />
                            </label>
                          ) : null}
                        </div>
                        {data.medicareEligible === "Y" ? (
                          <div class="radio radio-tab">
                            <label
                              for="coveringSpouseOrDependent"
                              class="control-label"
                            >
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;If
                              <Text id="app.san1" />
                            </label>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input
                              autoComplete="off"
                              spellcheck="false"
                              aria-autocomplete="both"
                              aria-haspopup="false"
                              type="radio"
                              name="coveringSpouseOrDependent"
                              id="coveringSpouseOrDependentY"
                              value="Y"
                              checked={data.coveringSpouseOrDependent === "Y"}
                              onChange={this.props.handleChange}
                            />{" "}
                            <label
                              for="coveringSpouseOrDependent"
                              class="radio-sandiego-retiree"
                            >
                              <Text id="app.Yes" />
                            </label>
                            <input
                              autoComplete="off"
                              spellcheck="false"
                              aria-autocomplete="both"
                              aria-haspopup="false"
                              type="radio"
                              name="coveringSpouseOrDependent"
                              id="coveringSpouseOrDependentN"
                              value="N"
                              checked={data.coveringSpouseOrDependent === "N"}
                              onChange={this.props.handleChange}
                            />
                            <label
                              for="coveringSpouseOrDependent"
                              class="radio-sandiego-retiree"
                            >
                              {" "}
                              No
                            </label>
                            <label class="control-label">
                              <Text id="app.san2" />
                            </label>
                          </div>
                        ) : null}
                      </>
                    ) : (
                      <div class="radio radio-tab">
                        <label
                          for="coveringSpouseOrDependent"
                          class="control-label"
                        >
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;If
                          <Text id="app.san1" />
                        </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="radio"
                          name="coveringSpouseOrDependent"
                          id="coveringSpouseOrDependentY"
                          value="Y"
                          checked={data.coveringSpouseOrDependent === "Y"}
                          onChange={this.props.handleChange}
                        />{" "}
                        <label
                          for="coveringSpouseOrDependent"
                          class="radio-sandiego-retiree"
                        >
                          <Text id="app.Yes" />
                        </label>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="radio"
                          name="coveringSpouseOrDependent"
                          id="coveringSpouseOrDependentN"
                          value="N"
                          checked={data.coveringSpouseOrDependent === "N"}
                          onChange={this.props.handleChange}
                        />
                        <label
                          for="coveringSpouseOrDependent"
                          class="radio-sandiego-retiree"
                        >
                          {" "}
                          No
                        </label>
                        <label class="control-label">
                          <Text id="app.san2" />
                        </label>
                      </div>
                    )}

                    {data.coveringSpouseOrDependent === "Y" ? (
                      <>
                        <div class="surviving-spouse-city-SanDiego-retiree">
                          <label class="control-label">
                            <Text id="app.san3" />:{" "}
                          </label>
                        </div>

                        <div class="surviving-spouse-city-SanDiego-retiree">
                          <div class="col-md-3">
                            <label for="lastName" class="control-label">
                              <Text id="app.LastName" />:
                            </label>
                            <input
                              autoComplete="off"
                              spellcheck="false"
                              aria-autocomplete="both"
                              aria-haspopup="false"
                              type="text"
                              id="coveringSpouseOrDependentLastName"
                              class={"form-control"}
                              value={data.coveringSpouseOrDependentLastName}
                              maxLength="40"
                              onChange={this.props.handleChange}
                              name="coveringSpouseOrDependentLastName"
                            />
                          </div>
                          <div class="col-md-3">
                            <label for="firstName" class="control-label">
                              <Text id="app.FirstName" />
                            </label>
                            <input
                              autoComplete="off"
                              spellcheck="false"
                              aria-autocomplete="both"
                              aria-haspopup="false"
                              type="text"
                              id="coveringSpouseOrDependentFirstName"
                              name="coveringSpouseOrDependentFirstName"
                              value={data.coveringSpouseOrDependentFirstName}
                              maxLength="40"
                              onChange={this.props.handleChange}
                              class={"form-control"}
                            />
                          </div>
                          <div
                            class={
                              this.props.lang === "es" ? "col-md-4" : "col-md-3"
                            }
                          >
                            <label for="middleInitial" class="control-label">
                              <Text id="app.MiddleInitial" />:
                            </label>
                            <input
                              autoComplete="off"
                              spellcheck="false"
                              aria-autocomplete="both"
                              aria-haspopup="false"
                              type="text"
                              class="form-control"
                              value={data.coveringSpouseOrDependentMiddleName}
                              maxLength="40"
                              onChange={this.props.handleChange}
                              id="coveringSpouseOrDependentMiddleName"
                              name="coveringSpouseOrDependentMiddleName"
                            />
                          </div>
                        </div>
                        <br />
                        <br />
                        {planCategory === "RETIREE" ? (
                          <div class="radio radio-tab">
                            <p class="medicare-note">
                              <strong>
                                <Text id="app.NOTE" />:{" "}
                              </strong>
                              <Text id="app.san6" />.
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    ) : data.coveringSpouseOrDependent === "N" ? (
                      <div class="surviving-spouse-city-SanDiego-retiree">
                        <div class="col-md-9">
                          <label class="control-label">
                            <Text id="app.san4" />:
                          </label>
                          <br />
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="text"
                            class="form-control"
                            name="coveringSpouseOrDependentEmployeeName"
                            id="coveringSpouseOrDependentEmployeeNameId"
                            value={data.coveringSpouseOrDependentEmployeeName}
                            maxLength="40"
                            onChange={this.props.handleChange}
                          />
                        </div>
                      </div>
                    ) : null}
                  </>
                ) : data.retiree === "N" ? (
                  <div class="radio radio-tab">
                    <label
                      for="survivingSpouseCitySanDiegoRetiree"
                      class="control-label"
                    >
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <Text id="app.san7" />
                    </label>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="radio"
                      name="survivingSpouseCitySanDiegoRetiree"
                      id="survivingSpouseCitySanDiegoRetireeY"
                      value="Y"
                      checked={data.survivingSpouseCitySanDiegoRetiree === "Y"}
                      onChange={this.props.handleChange}
                    />{" "}
                    <label
                      for="survivingSpouseCitySanDiegoRetiree"
                      class="radio-sandiego-retiree"
                    >
                      <Text id="app.Yes" />
                    </label>
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="radio"
                      name="survivingSpouseCitySanDiegoRetiree"
                      id="survivingSpouseCitySanDiegoRetireeN"
                      value="N"
                      checked={data.survivingSpouseCitySanDiegoRetiree === "N"}
                      onChange={this.props.handleChange}
                    />
                    <label
                      for="survivingSpouseCitySanDiegoRetiree"
                      class="radio-sandiego-retiree"
                    >
                      {" "}
                      No
                    </label>
                    {data.survivingSpouseCitySanDiegoRetiree === "Y" ? (
                      <>
                        <div class="surviving-spouse-city-SanDiego-retiree">
                          <div class="col-md-3">
                            <label for="lastName" class="control-label">
                              <Text id="app.rtlast" />:
                            </label>
                            <input
                              autoComplete="off"
                              spellcheck="false"
                              aria-autocomplete="both"
                              aria-haspopup="false"
                              type="text"
                              id="survivingSpouseCitySanDiegoRetireeLastName"
                              class={"form-control"}
                              value={
                                data.survivingSpouseCitySanDiegoRetireeLastName
                              }
                              maxLength="40"
                              onChange={this.props.handleChange}
                              name="survivingSpouseCitySanDiegoRetireeLastName"
                            />
                          </div>
                          <div class="col-md-3">
                            <label for="firstName" class="control-label">
                              <Text id="app.rtfirst" />:
                            </label>
                            <input
                              autoComplete="off"
                              spellcheck="false"
                              aria-autocomplete="both"
                              aria-haspopup="false"
                              type="text"
                              id="survivingSpouseCitySanDiegoRetireeFirstName"
                              name="survivingSpouseCitySanDiegoRetireeFirstName"
                              value={
                                data.survivingSpouseCitySanDiegoRetireeFirstName
                              }
                              maxLength="40"
                              onChange={this.props.handleChange}
                              class={"form-control"}
                            />
                          </div>
                          <div class="col-md-3">
                            <label for="middleInitial" class="control-label">
                              <Text id="app.rtmiddle" />:
                            </label>
                            <input
                              autoComplete="off"
                              spellcheck="false"
                              aria-autocomplete="both"
                              aria-haspopup="false"
                              type="text"
                              class="form-control"
                              value={
                                data.survivingSpouseCitySanDiegoRetireeMiddleName
                              }
                              maxLength="40"
                              onChange={this.props.handleChange}
                              id="survivingSpouseCitySanDiegoRetireeMiddleName"
                              name="survivingSpouseCitySanDiegoRetireeMiddleName"
                            />
                          </div>
                        </div>
                        <br />
                        <br />
                        {planCategory === "RETIREE" ? (
                          ""
                        ) : (
                          <div class="radio radio-tab">
                            <p class="medicare-note">
                              <strong>
                                <Text id="app.NOTE" />:{" "}
                              </strong>
                              <Text id="app.san8" />.
                            </p>
                          </div>
                        )}
                      </>
                    ) : null}
                  </div>
                ) : null}
              </>
            ) : null}

            {formerEmpOfSharp || planCategory === "RETIREE" ? (
              <div class="form-group row">
                <div class={this.props.lang === "es" ? "col-md-4" : "col-md-3"}>
                  <label for="proposedEffDate" class="control-label">
                    <Text id="app.Effectdate" />*
                  </label>
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    class={
                      clickedSaveNextIds.includes("next1") &&
                      (data.proposedEffDate === "" ||
                        this.props?.proposedvalid === false ||
                        !moment(
                          data.proposedEffDate,
                          "MM/DD/YYYY",
                          true
                        ).isValid())
                        ? "error-input"
                        : "form-control"
                    }
                    maxLength="10"
                    value={data.proposedEffDate}
                    onChange={this.props.handleDateNew}
                    onClick={(e) =>
                      this.props.handleReqEffDates("proposedEffDate")
                    }
                    name="proposedEffDate"
                    id="proposedEffDate"
                    placeholder="MM/DD/YYYY"
                    required=""
                  />
                </div>
                {formerEmpOfSharp ? (
                  <div class="col-md-3">
                    <label for="Socialnumber" class="control-label">
                      <Text id="app.Socialnumber" />*
                    </label>
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      id="Socialnumber"
                      name="Socialnumber"
                      value={Socialnumber}
                      onChange={this.props.handleNumberChange}
                      class={
                        clickedSaveNextIds.includes("next1") &&
                        Socialnumber.length != 9
                          ? "error-input"
                          : "form-control"
                      }
                      required=""
                      maxLength="9"
                    />
                  </div>
                ) : null}
              </div>
            ) : null}
            <div class="form-group row">
              <div class="col-md-3">
                <fieldset class={ie ? "radio iemargin3" : "radio"}>
                  <legend>
                    <Text id="app.Prefix" />
                  </legend>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="radio"
                      id="mr"
                      name="prefix"
                      class="custom-control-input"
                      value="MR."
                      checked={data.prefix === "MR." ? true : false}
                      onChange={this.props.handleChange}
                    />
                    <label for="mr" class="radio-inline custom-control-label">
                      <Text id="app.Mr" />
                    </label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="radio"
                      id="mrs"
                      name="prefix"
                      class="custom-control-input"
                      value="MRS."
                      checked={data.prefix === "MRS." ? true : false}
                      onChange={this.props.handleChange}
                    />
                    <label for="mrs" class="radio-inline custom-control-label">
                      <Text id="app.Mrs" />
                    </label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="radio"
                      id="ms"
                      name="prefix"
                      class="custom-control-input"
                      value="MS."
                      checked={data.prefix === "MS." ? true : false}
                      onChange={this.props.handleChange}
                    />
                    <label for="ms" class="radio-inline custom-control-label">
                      <Text id="app.Ms" />
                    </label>
                  </div>
                </fieldset>
              </div>
              <div class="col-md-3">
                <label for="firstName" class="control-label">
                  <Text id="app.FirstName" />
                </label>
                <input
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={data.firstName}
                  maxLength="20"
                  onChange={this.props.handleChange}
                  class={
                    clickedSaveNextIds.includes("next1") &&
                    data.firstName === ""
                      ? "error-input"
                      : "form-control"
                  }
                  required=""
                />
              </div>

              <div class="col-md-3">
                <label for="lastName" class="control-label">
                  <Text id="app.LastName" />
                </label>
                <input
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                  type="text"
                  id="lastName"
                  class={
                    clickedSaveNextIds.includes("next1") && data.lastName === ""
                      ? "error-input"
                      : "form-control"
                  }
                  value={data.lastName}
                  maxLength="20"
                  onChange={this.props.handleChange}
                  name="lastName"
                  required=""
                />
              </div>
              <div class="col-md-3">
                <label for="middleInitial" class="control-label">
                  <Text id="app.MI" />
                </label>
                <input
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                  type="text"
                  class="form-control"
                  value={data.middleInitial}
                  maxLength="20"
                  onChange={this.props.handleChange}
                  id="middleInitial"
                  name="middleInitial"
                />
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-3">
                <label for="birthDate" class="control-label">
                  <Text id="app.BirthDate" />
                </label>
                <input
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                  class={
                    clickedSaveNextIds.includes("next1") &&
                    (data.birthDate === "" ||
                      !moment(data.birthDate, "MM/DD/YYYY", true).isValid())
                      ? "error-input"
                      : "form-control"
                  }
                  value={data.birthDate}
                  maxLength="10"
                  onChange={this.props.handleDate}
                  onClick={(e) => this.props.handleDates("birthDate")}
                  name="birthDate"
                  id="birthDate"
                  placeholder="MM/DD/YYYY"
                  required=""
                />
              </div>
              <div class="col-md-3">
                <fieldset
                  class={ie ? "radio radio-tab iemargin" : "radio radio-tab"}
                >
                  <legend
                    class={
                      clickedSaveNextIds.includes("next1") && data.sex === ""
                        ? "invalid-date"
                        : "control-label"
                    }
                    id="sex"
                  >
                    <Text id="app.Sex" />
                  </legend>
                  <div
                    class={
                      this.props.lang === "es"
                        ? "custom-control custom-radio custom-control-inline sp_step1margin "
                        : "custom-control custom-radio custom-control-inline"
                    }
                  >
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="radio"
                      value="M"
                      checked={data.sex === "M"}
                      onChange={(e) => {
                        this.props.handleChange(e);
                      }}
                      name="sex"
                      id="male"
                      class="custom-control-input"
                      style={{ zIndex: -2 }}
                    />
                    <label for="male" class="radio-inline custom-control-label">
                      <Text id="app.Male" />
                    </label>
                  </div>
                  <div
                    class={
                      this.props.lang === "es"
                        ? "custom-control custom-radio custom-control-inline sp_step1margin "
                        : "custom-control custom-radio custom-control-inline"
                    }
                  >
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="radio"
                      value="F"
                      name="sex"
                      checked={data.sex === "F"}
                      onChange={(e) => {
                        this.props.handleChange(e);
                      }}
                      id="female"
                      class="custom-control-input"
                      style={{ zIndex: -2 }}
                    />
                    <label
                      for="female"
                      class="radio-inline custom-control-label"
                    >
                      <Text id="app.Female" />
                    </label>
                  </div>
                </fieldset>
              </div>
              {planCategory === "INDIVIDUAL" || formerEmpOfSharp ? (
                <>
                  <div class="col-md-3">
                    <label for="cellPhoneNum" class="control-label">
                      <Text id="app.CellPhoneNumber" />
                    </label>
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      id="cellPhoneNum"
                      name="cellPhoneNum"
                      value={data.cellPhoneNum}
                      maxLength="10"
                      onChange={this.props.handleChange}
                      class="form-control"
                      // placeholder="(   )   -"
                      // maxLength="14"
                    />
                  </div>
                  <div class="col-md-3">
                    <label for="primaryPhone" class="control-label">
                      <Text id="app.HomeNumber" />*
                    </label>
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      id="primaryPhone"
                      value={data.primaryPhoneNum}
                      onChange={this.props.handleChange}
                      name="primaryPhoneNum"
                      // className="form-control"
                      class={
                        clickedSaveNextIds.includes("next1") &&
                        (data.primaryPhoneNum === "" ||
                          // data.primaryPhoneNum.indexOf("(") === -1 ||
                          // data.primaryPhoneNum.indexOf(")") === -1
                          data.primaryPhoneNum?.length < 10)
                          ? "error-input"
                          : "form-control"
                      }
                      // placeholder="(   )   -"
                      required=""
                      // maxLength="14"
                      maxLength="10"
                    />
                  </div>
                  <div class="col-md-3">
                    <label for="OtherPhone" class="control-label">
                      <Text id="app.OtherPhoneNumber" />
                    </label>
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      id="OtherPhone"
                      value={data.otherPhone}
                      onChange={this.props.handleChange}
                      name="otherPhone"
                      class="form-control"
                      // placeholder="(   )   -"
                      // maxLength="14"
                      maxLength="10"
                    />
                  </div>
                </>
              ) : (
                <div class="col-md-3">
                  <label for="primaryPhone" class="control-label">
                    {planCategory === "RETIREE" ? (
                      <Text id="app.PrimaryPhoneNumberSharp" />
                    ) : (
                      <Text id="app.PrimaryPhoneNumber" />
                    )}
                  </label>
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="text"
                    id="primaryPhoneNum"
                    value={data.primaryPhoneNum}
                    onChange={this.props.handleChange}
                    name="primaryPhoneNum"
                    class={
                      clickedSaveNextIds.includes("next1") &&
                      (data.primaryPhoneNum === "" ||
                        // data.primaryPhoneNum?.indexOf("(") === -1 ||
                        // data.primaryPhoneNum?.indexOf(")") === -1
                        data.primaryPhoneNum.length < 10)
                        ? "error-input"
                        : "form-control"
                    }
                    // placeholder="(   )   -"
                    required=""
                    maxLength="10"
                  />
                </div>
              )}
              {!(planCategory === "INDIVIDUAL" || formerEmpOfSharp) ? (
                <div class="col-md-3">
                  <label for="cellPhoneNum" class="control-label">
                    <Text id="app.CellPhoneNumber" />
                  </label>
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="text"
                    id="cellPhoneNum"
                    name="cellPhoneNum"
                    value={data.cellPhoneNum}
                    onChange={this.props.handleChange}
                    class="form-control"
                    // placeholder="(   )   -"
                    // maxLength="14"
                    maxLength="10"
                  />
                </div>
              ) : null}
            </div>
            {planCategory === "RETIREE" && (
              <div class="form-group row">
                <div class="col-md-3">
                  <label for="OtherPhone" class="control-label">
                    <Text id="app.OtherPhoneNumber" />
                  </label>
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="text"
                    id="OtherPhone"
                    value={data.otherPhone}
                    onChange={this.props.handleChange}
                    name="otherPhone"
                    class="form-control"
                    // placeholder="(   )   -"
                    maxLength="10"
                  />
                </div>
              </div>
            )}

            {planCategory !== "RETIREE" ? (
              <>
                <div class="form-group row">
                  <div class="col-md-12">
                    <label for="clinicName" class="control-label">
                      <Text id="step2.Email" />:
                    </label>
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      id="emailAddress"
                      name="emailAddress"
                      value={data.emailAddress}
                      maxLength="50"
                      onChange={this.props.handleChange}
                      class="form-control"
                    />
                  </div>
                </div>
              </>
            ) : null}
            <div class="form-group row">
              <div class="col-md-12">
                <label for="permanentAddrStreet" class="control-label">
                  <Text id="app.PermanentAddress" />{" "}
                  <strong>
                    (<Text id="app.POBox" />
                    )*
                  </strong>
                </label>
                <input
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                  type="text"
                  name="permanentAddrStreet"
                  id="permanentAddrStreet"
                  value={data.permanentAddrStreet}
                  onChange={this.props.handleChange}
                  class={
                    clickedSaveNextIds.includes("next1") &&
                    data.permanentAddrStreet === ""
                      ? "error-input"
                      : "form-control"
                  }
                  required=""
                  maxLength="50"
                />
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-3">
                <label for="permanentCity" class="control-label">
                  <Text id="app.City" />*
                </label>
                <input
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                  type="text"
                  class={
                    clickedSaveNextIds.includes("next1") &&
                    data.permanentCity === ""
                      ? "error-input"
                      : "form-control"
                  }
                  value={data.permanentCity}
                  onChange={this.props.handleChange}
                  name="permanentCity"
                  id="permanentCity"
                  required=""
                  maxLength="20"
                />
              </div>

              <div class="col-md-3">
                <label for="permanentCounty" class="control-label">
                  <Text id="app.County" />
                </label>
                <input
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                  type="text"
                  style={{ cursor: "not-allowed" }}
                  class="form-control"
                  name="permanentCounty"
                  id="permanentCounty"
                  // value={data.permanentCounty}
                  value={
                    this.props.preEnrollInfo.appNumber
                      ? this.props.deeplink
                        ? this.props.dpcountyName
                        : this.props.preEnrollInfo.permanentAddress.county
                      : this.props.deeplink
                      ? this.props.dpcountyName
                      : this.props?.ZipCodes[0]?.countyName
                  }
                  disabled
                />
              </div>

              <div class="col-md-3">
                <label for="permanentState" class="control-label">
                  <Text id="app.State" />
                </label>
                <input
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                  type="text"
                  style={{ cursor: "not-allowed" }}
                  class="form-control"
                  name="permanentState"
                  id="permanentState"
                  value="CA"
                  disabled
                />
              </div>

              <div class="col-md-3">
                <label for="permanentZip" class="control-label">
                  <Text id="app.ZIPCode" />*
                </label>
                <input
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                  type="text"
                  class={
                    clickedSaveNextIds.includes("next1") &&
                    data.permanentZip?.length < 5
                      ? "error-input"
                      : "form-control"
                  }
                  name="permanentZip"
                  id="permanentZip"
                  minlength="5"
                  value={data.permanentZip}
                  onChange={this.props.handleNumberChange}
                  maxLength="5"
                  required=""
                />
              </div>
            </div>
            <div class="form-group row">
              <div
                style={{
                  display: ie ? "inline-flex" : "",
                }}
              >
                <label for="language" class="control-label mr-2">
                  <strong>
                    <Text id="app.mailingaddress" />
                  </strong>
                </label>
                <div class="custom-control custom-checkbox custom-control-inline mt-3">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="checkbox"
                    name="mailingAddressRequired"
                    id="mailingAddressRequired"
                    class="custom-control-input"
                    checked={
                      data.mailingAddressRequired === "YES" ||
                      (this.props.data.mailingAddr != "" &&
                        this.props.data.mailingAddr != null) ||
                      (this.props.data.mailingCity != "" &&
                        this.props.data.mailingCity != null) ||
                      (this.props.data.mailingzip != "" &&
                        this.props.data.mailingzip != null)
                    }
                    onChange={this.props.handleCheckbox2}
                  />
                  <label
                    for="mailingAddressRequired"
                    class="radio-inline custom-control-label"
                    style={{
                      marginTop: ie ? "0px" : "auto",
                    }}
                  >
                    <strong>
                      <Text id="app.No" />
                    </strong>
                  </label>
                </div>
              </div>
            </div>
            {this.props.data.mailingAddressRequired === "YES" ||
            (this.props.data.mailingAddr != "" &&
              this.props.data.mailingAddr != null) ||
            (this.props.data.mailingAddr2 != "" &&
              this.props.data.mailingAddr2 != null) ||
            (this.props.data.mailingCity != "" &&
              this.props.data.mailingCity != null) ||
            (this.props.data.mailingzip != "" &&
              this.props.data.mailingzip != null) ? (
              <div id="mailing-adddress">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label for="mailingAddr" class="control-label">
                      <Text id="app.maillingAdd" />*
                    </label>
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      maxLength="50"
                      type="text"
                      class={
                        clickedSaveNextIds.includes("next1") &&
                        data.mailingAddr === ""
                          ? "error-input"
                          : "form-control"
                      }
                      value={data.mailingAddr}
                      onChange={this.props.handleChange}
                      name="mailingAddr"
                      id="mailingAddr"
                      required=""
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-3">
                    <label for="mailingCity" class="control-label">
                      <Text id="app.City" />*
                    </label>
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      class={
                        clickedSaveNextIds.includes("next1") &&
                        data.mailingCity === ""
                          ? "error-input"
                          : "form-control"
                      }
                      value={data.mailingCity}
                      onChange={this.props.handleChange}
                      name="mailingCity"
                      id="mailingCity"
                      required=""
                      maxLength="20"
                    />
                  </div>
                  <div class="col-md-3">
                    <label
                      for="mailingState"
                      // style={{ marginTop: "1em" }}
                    >
                      <Text id="app.State" />
                    </label>
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      class="form-control"
                      name="mailingState"
                      id="mailingState"
                      // value={data.mailingState}
                      value="CA"
                      // onChange={this.props.handleChange}
                      disabled
                    />
                  </div>
                  <div class="col-md-3">
                    <label for="mailingzip" class="control-label">
                      <Text id="app.ZIPCode" />*
                    </label>
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      class={
                        clickedSaveNextIds.includes("next1") &&
                        data.mailingzip === ""
                          ? "error-input"
                          : "form-control"
                      }
                      name="mailingzip"
                      id="mailingzip"
                      minlength="5"
                      value={data.mailingzip}
                      onChange={this.props.handleNumberChange}
                      maxLength="5"
                      required=""
                    />
                  </div>
                </div>
              </div>
            ) : null}
            {planCategory === "INDIVIDUAL" ? (
              <div class="form-group row">
                <div class="col-md-6">
                  <p>
                    <label for="medicareNumber" class="control-label">
                      <Text id="app.MedicareNo" />*
                    </label>
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      // pattern="/[a-zA-Z0-9]{10,11}/"
                      placeholder="XXXXXXXXXXX"
                      name="medicareNumber"
                      id="medicareNumber"
                      minlength="11"
                      maxLength="11"
                      class={
                        clickedSaveNextIds.includes("next1") &&
                        (data.medicareNumber === "" ||
                          (data.medicareNumber &&
                            data.medicareNumber.length < 11))
                          ? "error-input"
                          : "form-control"
                      }
                      value={data.medicareNumber}
                      onChange={this.props.handleChange}
                      required=""
                    />
                  </p>
                </div>
                {this.props.agentLogin === true ? (
                  <div className="col-md-6">
                    <Button
                      className="btn btn-secondary-enroll chkbutton "
                      id="checkEligibity"
                      onButtonClick={this.props.checkEligibility}
                      buttonLabel={"Check Eligibility"}
                    />
                  </div>
                ) : null}
              </div>
            ) : null}

            {/* {(year==="2022")  && (selectedPlan === "SDAB20" ||
                  selectedPlan === "SDABWD20"||
                  selectedPlan === "SDAP20"||
                  selectedPlan === "SDAPWD20"|| selectedPlan === "SDAHMO200")?
                  (
                    <React.Fragment>
                 
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label for="emailAddress" class="control-label">
                        <Text id="app.email" />
                      </label>
                      <input autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                        type="email"
                        id="emailAddress"
                        name="emailAddress"
                        value={data.emailAddress}
                        onChange={this.props.handleChange}
                        class="form-control"
                        required=""
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div
                      class="col-md-12"
                      style={{
                        display: formerEmpOfSharp ? "flex" : "none",
                      }}
                    >
                      <div class="checkbox checkbox-tab">
                        <div class="custom-control custom-checkbox custom-control-inline">
                          <input autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                            type="checkbox"
                            id="shpmp"
                            name="shpmp"
                            class="custom-control-input"
                            checked={data.shpmp === "Y"}
                            onChange={this.props.handleChange}
                          />
                          <label for="shpmp" class="custom-control-label">
                            <strong>
                              <Text id="app.Please" />.
                            </strong>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="checkbox checkbox-tab">
                        <div class="custom-control custom-checkbox custom-control-inline">
                          <input autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                            type="checkbox"
                            checked={data.emailAlert === "Y"}
                            id="emailAlert"
                            name="emailAlert"
                            defaultChecked
                            class="custom-control-input"
                            onChange={this.props.handleChange}
                          />
                          <label for="emailAlert" class="custom-control-label">
      
                              <strong>
                                <Text id="app.news" />.
                              </strong>
                            
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
                  )
                  :null} */}
            {console.log(
              planCategory,
              "  ",
              this.state.formerEmpOfSharp,
              "   "
            )}
            {!(planCategory === "INDIVIDUAL" || this.state.formerEmpOfSharp) ? (
              <React.Fragment>
                <div class="form-group row">
                  <div class="col-md-12">
                    <label for="emailAddress" class="control-label">
                      <Text id="app.email" />
                    </label>
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="email"
                      id="emailAddress"
                      name="emailAddress"
                      value={data.emailAddress}
                      onChange={this.props.handleChange}
                      class="form-control"
                      required=""
                      maxLength="50"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <div
                    class="col-md-12"
                    style={{
                      display: formerEmpOfSharp ? "flex" : "none",
                    }}
                  >
                    <div class="checkbox checkbox-tab">
                      <div class="custom-control custom-checkbox custom-control-inline">
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          id="shpmp"
                          name="shpmp"
                          class="custom-control-input"
                          checked={data.shpmp === "Y"}
                          onChange={this.props.handleChange}
                        />
                        <label for="shpmp" class="custom-control-label">
                          <strong>
                            <Text id="app.Please" />.
                          </strong>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="checkbox checkbox-tab">
                      <div class="custom-control custom-checkbox custom-control-inline">
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          checked={data.emailOptionIndicator === "Y"}
                          id="emailAlert"
                          name="emailOptionIndicator"
                          defaultChecked
                          class="custom-control-input"
                          onChange={this.props.handleChange}
                        />
                        <label for="emailAlert" class="custom-control-label">
                          {planCategory === "RETIREE" ? (
                            <strong>
                              <Text id="app.news1" />
                            </strong>
                          ) : (
                            <strong>
                              <Text id="app.news" />.
                            </strong>
                          )}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                {planCategory === "RITREE" ? (
                  <div class="form-group row">
                    <div class="col-md-6">
                      <p>
                        <label for="medicareNumber" class="control-label">
                          <Text id="app.MedicareNo" />*
                        </label>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="text"
                          pattern="/[a-zA-Z0-9]{10,11}/"
                          placeholder="XXXXXXXXXXX"
                          name="medicareNumber"
                          id="medicareNumber"
                          minlength="10"
                          maxLength="11"
                          class={
                            clickedSaveNextIds.includes("next1") &&
                            (data.medicareNumber === "" ||
                              (data.medicareNumber &&
                                data.medicareNumber.length < 10))
                              ? "error-input"
                              : "form-control"
                          }
                          value={data.medicareNumber}
                          onChange={this.props.handleChange}
                          required=""
                        />
                      </p>
                    </div>
                    {this.props.agentLogin === true ? (
                      <div className="col-md-6">
                        <Button
                          className="btn btn-secondary-enroll chkbutton "
                          id="checkEligibity"
                          onButtonClick={this.props.checkEligibility}
                          buttonLabel={"Check Eligibility"}
                        />
                      </div>
                    ) : null}
                  </div>
                ) : null}
                {planCategory === "INDIVIDUAL" ? (
                  <div class="form-group row">
                    <fieldset
                      class="radio radio-tab mt-3"
                      id="c_qns1"
                      name="c_qns1"
                      onChange={this.props.handleChange}
                      value={data.c_qns1}
                    >
                      <legend>
                        <Text id="app.drugCoverageSharp" />{" "}
                      </legend>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="radio"
                          name="isDrugCoverage"
                          id="c_q2_yes"
                          class="custom-control-input"
                          value="Y"
                          checked={data.isDrugCoverage === "Y" ? true : false}
                          onChange={this.props.handleChange}
                        />
                        <label
                          for="c_q2_yes"
                          class="radio-inline custom-control-label"
                        >
                          <Text id="app.Yes" />
                        </label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="radio"
                          name="isDrugCoverage"
                          id="c_q2_no"
                          class="custom-control-input"
                          value="N"
                          checked={data.isDrugCoverage === "N"}
                          onChange={this.props.handleChange}
                        />
                        <label
                          for="c_q2_no"
                          class="radio-inline custom-control-label"
                        >
                          <Text id="app.No" />
                        </label>
                      </div>
                    </fieldset>
                  </div>
                ) : null}
                {!formerEmpOfSharp && data.isDrugCoverage === "Y" ? (
                  <div class="row mt-3 mb-2">
                    <div class="col-md-4">
                      <label for="nameOfCoverage" class="control-label">
                        <Text id="app.coverage" /> * :
                      </label>
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        class={
                          clickedSaveNextIds.includes("next1") &&
                          data.nameOfCoverage === ""
                            ? "error-input"
                            : "form-control"
                        }
                        id="nameOfCoverage"
                        name="nameOfCoverage"
                        value={data.nameOfCoverage}
                        maxLength="30"
                        onChange={this.props.handleChange}
                      />
                    </div>
                    <div class="col-md-4">
                      <label
                        for="covMemberNumber"
                        class="control-label"
                        style={{ width: "356px" }}
                      >
                        <Text id="app.mebernumber" />
                        *:
                      </label>
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        class={
                          clickedSaveNextIds.includes("next1") &&
                          data.covMemberNumber === ""
                            ? "error-input"
                            : "form-control"
                        }
                        id="covMemberNumber"
                        name="covMemberNumber"
                        value={data.covMemberNumber}
                        maxLength="20"
                        onChange={this.props.handleChange}
                      />
                    </div>
                    <div class="col-md-4">
                      <label for="covGroupNumber" class="control-label">
                        <Text id="app.groupNo" /> * :
                      </label>
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        class={
                          clickedSaveNextIds.includes("next1") &&
                          data.covGroupNumber === ""
                            ? "error-input"
                            : "form-control"
                        }
                        id="covGroupNumber"
                        name="covGroupNumber"
                        value={data.covGroupNumber}
                        maxLength="30"
                        onChange={this.props.handleChange}
                      />
                    </div>
                  </div>
                ) : null}
                {planCategory !== "RETIREE" ? (
                  <div class="card">
                    <h3 class="card-header block-heading">
                      <Text id="app.imp" /> : <Text id="app.impsub" />
                    </h3>
                    <div class="panel">
                      <div class="card-body">
                        <ul>
                          {formerEmpOfSharp ? (
                            <>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <li>
                                <Text id="sharp.imp1" />.
                              </li>
                            </>
                          ) : (
                            <li>
                              <Text id="sharp.imp1" />.
                            </li>
                          )}
                          <li>
                            <Text id="sharp.imp2" />.
                          </li>
                          <li>
                            <Text id="app.imp3" />.
                          </li>
                          <li>
                            <Text id="app.imp4" />.
                          </li>
                          <li>
                            <Text id="app.imp5" />.
                          </li>
                          <li>
                            <Text id="sharp.imp6" />.
                          </li>

                          <li>
                            <Text id="app.imp7" />: <br />
                            <Text id="app.imp7sub1" />
                            <br />
                            <Text id="app.imp7sub2" />.
                          </li>

                          <li>
                            {" "}
                            <Text id="app.imp10" />
                          </li>
                          <br />
                        </ul>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div></div>
                {planCategory !== "RETIREE" ? (
                  <div class="form-group row">
                    <div class="col-md-4">
                      <label for="name" class="control-label">
                        <Text id="app.Name" />*
                      </label>
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        maxLength="50"
                        type="text"
                        id="name"
                        name="name"
                        value={data.name}
                        onChange={this.props.handleChange}
                        class={
                          clickedSaveNextIds.includes("next1") &&
                          this.props.data.name === ""
                            ? "error-input"
                            : "form-control"
                        }
                      />
                    </div>
                    <div class="col-md-4">
                      <label for="name" class="control-label">
                        <Text id="app.DigitalSignature" />
                      </label>
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        id="name"
                        name="name"
                        disabled="true"
                        style={{ cursor: "not-allowed" }}
                        value={data.name}
                        maxLength="50"
                        onChange={this.props.handleChange}
                        class={"form-control"}
                      />
                    </div>
                    <div class="col-md-4">
                      <label for="todayDate" class="control-label">
                        <Text id="app.TodayDate" />
                      </label>
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        style={{ cursor: "not-allowed" }}
                        id="todayDate"
                        name="todayDate"
                        disabled="true"
                        value={moment().format("MM/DD/YYYY")}
                        onChange={this.props.handleChange}
                        class={"form-control"}
                      />
                    </div>
                    <div class="col-md-12">
                      <fieldset
                        class="radio radio-tab mt-3"
                        id="authorizedrep_radio"
                      >
                        <legend>
                          <Text id="app.authorizedrepresentative" />{" "}
                        </legend>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="radio"
                            name="isAuthRepresentative"
                            id="authorizedRepresentative_Y"
                            class="custom-control-input"
                            value="Y"
                            onChange={this.props.handleChange}
                            checked={
                              data.isAuthRepresentative === "Y" ? true : false
                            }
                          />
                          <label
                            for="authorizedRepresentative_Y"
                            class="radio-inline custom-control-label"
                          >
                            <Text id="app.Yes" />
                          </label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="radio"
                            name="isAuthRepresentative"
                            id="authorizedRepresentative_no"
                            class="custom-control-input"
                            value="N"
                            onChange={this.props.handleChange}
                            checked={
                              data.isAuthRepresentative === "N" ? true : false
                            }
                          />
                          <label
                            for="authorizedRepresentative_no"
                            class="radio-inline custom-control-label"
                            checked={
                              data.isAuthRepresentative === "N" ? true : false
                            }
                          >
                            No
                          </label>
                        </div>
                      </fieldset>
                      <div class="form-group">
                        <strong>
                          <Text id="app.authorized" />:
                        </strong>
                      </div>
                      {data.isAuthRepresentative === "Y" ? (
                        <React.Fragment>
                          <div class="row mt-3">
                            <div class="col-md-6">
                              <label class="control-label" for="nameOfRep">
                                <Text id="app.Name" />*
                              </label>
                              <input
                                autoComplete="off"
                                spellcheck="false"
                                aria-autocomplete="both"
                                aria-haspopup="false"
                                type="text"
                                class={
                                  clickedSaveNextIds.includes("next1") &&
                                  this.props.data.nameOfRep === ""
                                    ? "error-input"
                                    : "form-control"
                                }
                                name="nameOfRep"
                                id="nameOfRep"
                                required=""
                                value={data.nameOfRep}
                                maxLength="20"
                                onChange={this.props.handleChange}
                              />
                            </div>
                            <div class="col-md-6">
                              <label class="control-label" for="relationOfRep">
                                <Text id="app.Enrollee" />*
                              </label>
                              <select
                                name="relationOfRep"
                                id="relationOfRep"
                                class={
                                  clickedSaveNextIds.includes("next1") &&
                                  this.props.data.relationOfRep === ""
                                    ? "error-input"
                                    : "form-control"
                                }
                                value={data.relationOfRep}
                                maxLength="10"
                                onChange={this.props.handleChange}
                              >
                                {this.props.authorizedrelations.map(
                                  (item, i) => {
                                    return (
                                      <option
                                        class="select-option"
                                        value={item.value}
                                        key={i}
                                      >
                                        {item.label}
                                      </option>
                                    );
                                  }
                                )}
                              </select>
                            </div>
                          </div>
                          <div class="row mt-3">
                            <div class="col-md-8">
                              <label
                                class="control-label"
                                for="authorizedRepAddr"
                              >
                                <Text id="app.address" />*
                              </label>
                              <input
                                autoComplete="off"
                                spellcheck="false"
                                aria-autocomplete="both"
                                aria-haspopup="false"
                                type="text"
                                class={
                                  clickedSaveNextIds.includes("next1") &&
                                  (this.props.data.addressOfRep === "" ||
                                    this.props.data.addressOfRep === null ||
                                    this.props.data.addressOfRep === undefined)
                                    ? "error-input"
                                    : "form-control"
                                }
                                id="authorizedRepAddr"
                                name="addressOfRep"
                                value={data.addressOfRep}
                                onChange={this.props.handleChange}
                                required=""
                                maxLength="50"
                              />
                            </div>
                            <div class="col-md-4">
                              <label
                                class="control-label"
                                for="phoneNumberOfRep"
                              >
                                <Text id="app.phno" />*
                              </label>
                              <input
                                autoComplete="off"
                                spellcheck="false"
                                aria-autocomplete="both"
                                aria-haspopup="false"
                                type="text"
                                id="phoneNumberOfRep"
                                value={data.phoneNumberOfRep}
                                onChange={this.props.handleChange}
                                name="phoneNumberOfRep"
                                class={
                                  clickedSaveNextIds.includes("next1") &&
                                  (data.phoneNumberOfRep === "" ||
                                    // data.phoneNumberOfRep.indexOf("(") === -1 ||
                                    // data.phoneNumberOfRep.indexOf(")") === -1
                                    data.phoneNumberOfRep.length < 10)
                                    ? "error-input"
                                    : "form-control"
                                }
                                // placeholder="(   )   -"
                                // required=""
                                maxLength="10"
                              />
                            </div>
                          </div>
                        </React.Fragment>
                      ) : null}
                      <fieldset
                        class="radio radio-tab mt-3"
                        id="licensed_sales_representative_radio"
                      >
                        <legend>
                          <Text id="app.License" />
                        </legend>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="radio"
                            name="isLicensedSalesRep"
                            id="licensedSalesRepresentative_Y"
                            class="custom-control-input"
                            value="Y"
                            onChange={this.props.handleChange}
                            checked={
                              data.isLicensedSalesRep === "Y" ? true : false
                            }
                          />
                          <label
                            for="licensedSalesRepresentative_Y"
                            class="radio-inline custom-control-label"
                          >
                            <Text id="app.Yes" />
                          </label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="radio"
                            name="isLicensedSalesRep"
                            id="licensedSalesRepresentative_no"
                            class="custom-control-input"
                            value="N"
                            onChange={this.props.handleChange}
                            checked={
                              data.isLicensedSalesRep === "N" ? true : false
                            }
                          />
                          <label
                            for="licensedSalesRepresentative_no"
                            class="radio-inline custom-control-label"
                          >
                            No
                          </label>
                        </div>
                      </fieldset>
                      {data.isLicensedSalesRep === "Y" ? (
                        <React.Fragment>
                          <div class="row">
                            <div class="col-md-6">
                              <label
                                class="control-label"
                                for="salesRepresentativeName"
                              >
                                <Text id="app.sale" />*
                              </label>
                              <input
                                autoComplete="off"
                                spellcheck="false"
                                aria-autocomplete="both"
                                aria-haspopup="false"
                                type="text"
                                class={
                                  clickedSaveNextIds.includes("next1") &&
                                  this.props.data.salRepName === ""
                                    ? "error-input"
                                    : "form-control"
                                }
                                name="salRepName"
                                id="salesRepresentativeName"
                                required=""
                                onChange={this.props.handleChange}
                                value={data.salRepName}
                                maxLength="50"
                              />
                            </div>
                            <div class="col-md-6">
                              <label
                                class="control-label"
                                for="salesRepresentativeLicenseNumber"
                              >
                                <Text id="app.Licenseno" />
                              </label>
                              <input
                                autoComplete="off"
                                spellcheck="false"
                                aria-autocomplete="both"
                                aria-haspopup="false"
                                type="text"
                                class="form-control"
                                name="salRepLicenseNumber"
                                id="salesRepresentativeLicenseNumber"
                                required=""
                                onChange={this.props.handleChange}
                                value={data.salRepLicenseNumber}
                                maxLength="50"
                              />
                            </div>
                          </div>
                        </React.Fragment>
                      ) : null}
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </React.Fragment>
            )}

            <p class="medicare-note">
              <strong>
                <Text id="app.NOTE" />:
              </strong>{" "}
              <Text id="app.notePart" />.
            </p>
            {this.props.preEnrollInfo?.appStatus != "READY" &&
              this.props.preEnrollInfo?.appStatus != "SUBMITTED" && (
                <button
                  class="btn btn-saveNext"
                  id="next1"
                  onClick={this.props.redirect}
                >
                  <Text id="app.Save_Next" />
                </button>
              )}
          </div>
        </div>
        {/* </div> */}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    year: state.webApp.year,
    lang: state.webApp.language,
    preEnrollInfo: state.webApp.preEnrollInfo,
    ZipCodes: state.webApp.zipCodes,
    deeplink: state.login.deeplink,
    dpcountyName: state.login.dpcountyName,
    agentLogin: state.login.agentLoggedIn,
  };
};
export default connect(mapStateToProps)(Step1);
